/* IMPORT */
import get from './get.js';
import isObservableBoolean from './is_observable_boolean.js';
import isObservableFrozen from './is_observable_frozen.js';
import isUntracked from './is_untracked.js';
import memo from './memo.js';
import resolve from './resolve.js';
import warmup from './warmup.js';
import { frozen } from '../objects/callable.js';
import { is, isFunction } from '../utils.js';
/* HELPERS */
const match = (condition, values, fallback) => {
    for (let i = 0, l = values.length; i < l; i++) {
        const value = values[i];
        if (value.length === 1)
            return value[0];
        if (is(value[0], condition))
            return value[1];
    }
    return fallback;
};
function _switch(when, values, fallback) {
    const isDynamic = isFunction(when) && !isObservableFrozen(when) && !isUntracked(when);
    if (isDynamic) {
        if (isObservableBoolean(when)) {
            return memo(() => resolve(match(when(), values, fallback)));
        }
        const value = warmup(memo(() => match(when(), values, fallback)));
        if (isObservableFrozen(value)) {
            return frozen(resolve(value()));
        }
        else {
            return memo(() => resolve(get(value)));
        }
    }
    else {
        const value = match(get(when), values, fallback);
        return frozen(resolve(value));
    }
}
/* EXPORT */
export default _switch;
